<template>
    <page>
        <tabs :activeTab="activeTab" :tabs="tabs" :onTabChange="onTabChange" />
    </page>
</template>

<script>
import Page from '@/components/layout/Page';
import Tabs from '@/components/layout/Tabs';

import Hotfix from './Hotfix/Hotfix';

export default {
    data() {
        return {
            activeTab: this.$route.params.tab || 'hotfix',
            tabs: [Hotfix],
        };
    },
    components: {
        Page,
        Tabs,
    },
    methods: {
        onTabChange(tab) {
            this.$router.push(`/tech/${tab.name}`, () => {});
        }
    }
}
</script>
